import packageJSON from "../../package.json";
import { ConfigHelper } from "../helpers/config-helper";

const getScopeUrl = (scope, baseURL) => {
    return `${baseURL}/${scope}`;
};

const getWorkerRegistration = async () => {
    try {
        const worker = await navigator.serviceWorker.ready;
        return worker;
    } catch (e) {
        console.log(`failed to retrive worker registration ${e.message}`);
    }
};

/**
 * @param {*} scope
 * @returns true if there is a worker already registerd and if it is updated
 */
const updateWorker = async (scope) => {
    let updated = false;
    try {
        const currentWorkerVersion = await ConfigHelper.getWorkerVersion();
        const packageWorkerVersion = packageJSON.version;
        if (currentWorkerVersion !== packageWorkerVersion) {
            const registration = await navigator.serviceWorker.getRegistration(`${scope}`);
            if (registration) {
                await registration.update();
                updated = true;
            }
            ConfigHelper.setWorkerVersion(packageWorkerVersion);
        }
    } catch (e) {
        console.warn(`Cant update warning, ${e.message}`);
    }
    return updated;
};

/**
 * register a new worker
 * @param {*} param0
 * @returns
 */
const registerWorker = async ({ scope = "", baseURL = "" }) => {
    const scopeURL = getScopeUrl(scope, baseURL);

    if (!(await updateWorker(scopeURL))) {
        return navigator.serviceWorker.register(`${baseURL}/ta-push-sw.js`, {
            scope: scopeURL
        });
    }
    return navigator.serviceWorker.getRegistration(scopeURL);
};

/**
 * return tab focused from client list with same url
 */
const isTabFocused = async (clients, urlToOpen) => {
    let matchingClient = null;

    try {
        const windowClients = await clients.matchAll({
            type: "window",
            includeUncontrolled: true
        });

        for (let i = 0; i < windowClients.length; i++) {
            const windowClient = windowClients[i];
            if (windowClient.url === urlToOpen) {
                matchingClient = windowClient;
                break;
            }
        }
    } catch (e) {
        console.log(e.message);
    }
    return matchingClient;
};

export { isTabFocused, getWorkerRegistration, registerWorker };
